import { useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import gsap from 'gsap';

import styles from './index.module.scss';
import Marquee from '../../../components/Marquee';

const cx = classNames.bind(styles);

const S03 = () => {
  const containerRef = useRef();
  const word01Ref = useRef();
  const word02Ref = useRef();
  const word03Ref = useRef();
  const word04Ref = useRef();
  const word05Ref = useRef();
  const word06Ref = useRef();
  const word07Ref = useRef();
  const word08Ref = useRef();
  const word09Ref = useRef();
  const word10Ref = useRef();
  const word11Ref = useRef();
  const word12Ref = useRef();
  const word13Ref = useRef();
  const word14Ref = useRef();
  const word15Ref = useRef();
  const word16Ref = useRef();
  const word17Ref = useRef();
  const word18Ref = useRef();
  const word19Ref = useRef();

  useEffect(() => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          scrub: true,
          pin: true,
          start: 'top top',
          end: '+=100%',
          pinSpacing: true,
        },
      })
      .to(word01Ref.current, { className: cx('enable') })
      .to(word02Ref.current, { className: cx('enable') })
      .to(word03Ref.current, { className: cx('enable') })
      .to(word04Ref.current, { className: cx('enable') })
      .to(word05Ref.current, { className: cx('enable') })
      .to(word06Ref.current, { className: cx('enable') })
      .to(word07Ref.current, { className: cx('enable') })
      .to(word08Ref.current, { className: cx('enable') })
      .to(word09Ref.current, { className: cx('enable') })
      .to(word10Ref.current, { className: cx('enable') })
      .to(word11Ref.current, { className: cx('enable') })
      .to(word12Ref.current, { className: cx('enable') })
      .to(word13Ref.current, { className: cx('enable') })
      .to(word14Ref.current, { className: cx('enable') })
      .to(word15Ref.current, { className: cx('enable') })
      .to(word16Ref.current, { className: cx('enable') })
      .to(word17Ref.current, { className: cx('enable') })
      .to(word18Ref.current, { className: cx('enable') })
      .to(word19Ref.current, { className: cx('enable') });
  }, []);

  return (
    <section ref={containerRef} className={cx('container')}>
      <div className={cx('wrapper')}>
        <p className={cx('desc')}>
          <span ref={word01Ref}>Say </span>
          <span ref={word02Ref}>hello </span>
          <span ref={word03Ref}>to </span>
          <span ref={word04Ref}>our </span>
          <span ref={word05Ref}>most </span>
          <span ref={word06Ref}>playful </span>
          <span ref={word07Ref}>collection </span>
          <span ref={word08Ref}>yet.</span>
          <br />
          <span ref={word09Ref}>Bright </span>
          <span ref={word10Ref}>colors, </span>
          <span ref={word11Ref}>bold </span>
          <span ref={word12Ref}>care </span>
          <span ref={word13Ref}>- </span>
          <span ref={word14Ref}>this </span>
          <span ref={word15Ref}>is </span>
          <span ref={word16Ref}>what </span>
          <span ref={word17Ref}>makes </span>
          <span ref={word18Ref}>LEVRAI </span>
          <span ref={word19Ref}>fun.</span>
        </p>
        <p className={cx('title')}> RORO &amp; COCO MULTI BALM </p>
      </div>
      <div className={cx('bottom')}>
        <Marquee />
      </div>
    </section>
  );
};

export default S03;
